var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',_vm._l((_vm.defaultProducts),function(product,index){return _c('vs-row',{key:("product_" + index)},[_c('DefaultProductRow',{attrs:{"product":product}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }